import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/ends-with";
import { find } from "lodash";
export default {
  methods: {
    getEventType({
      currentTarget
    }, eventSuffix = "-event") {
      return find(currentTarget.classList, className => _endsWithInstanceProperty(className).call(className, eventSuffix)).replace(eventSuffix, "");
    },
    emitEvent(rowData, event) {
      this.$emit(this.getEventType(event), rowData, event);
    }
  }
};